import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';

const Forbidden = () => (
  <div className='flex min-h-[60vh] flex-col items-center justify-center gap-5 p-10 text-center'>
    <span className='inline-flex h-16 w-16 items-center justify-center rounded-full bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-400'>
      <Lock className='h-7 w-7' />
    </span>
    <div className='max-w-md'>
      <p className='text-xs font-semibold uppercase tracking-widest text-red-600 dark:text-red-400'>
        403 — Super-admin only
      </p>
      <h1 className='mt-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white'>
        You don&apos;t have access to this area.
      </h1>
      <p className='mt-2 text-sm text-gray-600 dark:text-gray-400'>
        The Continuum super-admin console is restricted to users with the
        &lsquo;superuser&rsquo; role. If you think this is a mistake, contact
        your administrator.
      </p>
    </div>
    <Link
      to='/dashboard'
      className='inline-flex items-center gap-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-[#1D2838] px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 hover:border-primary-green transition'
    >
      Back to dashboard
    </Link>
  </div>
);

export default Forbidden;
